import { useEffect } from 'react';

import { appendCheckpoint } from './tracking';
import { type TrackingKey } from './types';

export function PerfTrackingCheckpoint({
  trackingKey,
  checkpointName,
  condition = true,
}: {
  trackingKey: TrackingKey;
  checkpointName: string;
  condition?: boolean;
}) {
  useEffect(() => {
    if (!condition) return;
    appendCheckpoint({ key: trackingKey, checkpointName });
  }, [trackingKey, checkpointName, condition]);
  return null;
}
